"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
function parse(results, { reason, maxScore = null }) {
    const hits = results.body.hits.hits;
    return hits.map((hit) => ({
        ...hit._source,
        _score: maxScore ? Math.min(maxScore, hit._score) : hit._score,
        _reason: reason,
    }));
}
exports.parse = parse;
//# sourceMappingURL=utils.js.map